var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Uploader',_vm._g(_vm._b({ref:"uploader",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'Uploader',{ safeRemoveFn: _vm.safeRemoveFn, ..._vm.bindables },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }